export const ocplcCountryDropDown = `query GetOcplcCountryDropDown($filter: OcplcCountryDropDownRequest!) {
  ocplcCountryDropDown(filter: $filter) {
    countries {
      countryCode
      countryName
      regionCode
    }
  }
}`
